export default {
  add: {
    name: {
      "ui:autofocus": true,
    },
    organisationalUnitReference: {},
  },
  move: {
    newParentId: {
      "ui:autofocus": true,
    },
  },
  rename: {
    newName: {
      "ui:autofocus": true,
    },
  },
};
